import React, {PropsWithChildren} from 'react';
import {useAccount, useMsal} from '@azure/msal-react';
import axios from 'axios';

const RequestInterceptor = ({ children }:PropsWithChildren<{}>) => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);

    const loginRequest = {
        scopes: ["https://legeforeningenb2c.onmicrosoft.com/e2f42359-b1b3-4d7c-8e33-24f1360dc3b3/Data"],
        account: accounts[0]
    }

    /* eslint-disable no-param-reassign */
    axios.interceptors.request.use(async (config) => {
        if (!account) {
            throw Error('No active account! Verify a user has been signed in.');
        }

        const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account,
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;

        return config;
    });
    /* eslint-enable no-param-reassign */

    return (
        <>
            {children}
        </>
    );
};

export default RequestInterceptor;